import React, { useEffect, useState, useTransition } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  Stack,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import InfoComponent from './InfoComponent';
// import { useTranslation } from 'react-i18next';
import i18n from '../../../../i18n';
import { LocaleKey } from '../../../localizedGrid/locales';
import HtmlComponent from './HtmlComponent';

// interface InfoModalProps {
//   open: boolean;
//   onClose: () => void;
// }

interface InfoModalProps {
  open: boolean;
  onAccept: () => void;
  onCancel: () => void;
  kind: 'offer' | 'privacy';
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

const InfoModal: React.FC<InfoModalProps> = ({ open, onAccept, onCancel, kind }) => {
  // const { t } = useTranslation();
  const [contentOffer, setContentOffer] = useState('');
  const [contentPrivacy, setContentPrivacy] = useState('');
  const lang = i18n.language as LocaleKey;
  
  useEffect(() => {
    fetch(`${import.meta.env.VITE_BASENAME_PROD}/docs/${lang}/offer.html`)
      .then(response => response.text())
      .then(text => setContentOffer(text));
    fetch(`${import.meta.env.VITE_BASENAME_PROD}/docs/${lang}/privacy.html`)
      .then(response => response.text())
      .then(text => setContentPrivacy(text));
  }, [lang]);

  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>        

        <Typography id="modal-modal-title" variant="h6" component="h2">
          {/* Детальна інформація */}
        </Typography>
        <div id="modal-modal-description">
          {/* <InfoComponent /> */}
          <HtmlComponent htmlContent={kind === 'offer' ? contentOffer : contentPrivacy}/>
        </div>
        {/* <Button onClick={onClose} variant="contained" color="primary">
          Закрыть
        </Button> */}

        {false && (
        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
          {/* Кнопка "Отмена" */}
          <Button onClick={onCancel} variant="outlined" color="secondary">
            {/* {t('InfoModal.Cancel')} */}
          </Button>
          
          {/* Кнопка "Принимаю" */}
          <Button onClick={onAccept} variant="contained" color="primary">
            {/* {t('InfoModal.Accept')} */}
          </Button>
        </Stack>      
        )}
        </Box>
    </Modal>
  );
};

export default InfoModal;